<script>
import {cloneDeep, groupBy} from "lodash";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import RawData from "@/components/widgets/raw-data.vue";

export default {
    name: "posted-items",
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        MaskedInput,
        Multiselect,
        RawData
    },
    data(){
        return {
            tableData: [],
            filter: "",
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            currentPage: 1,
            returnedLoading: false,
            quarterOptions: [
                {
                    text: "1st Quarter",
                    value: 1,
                },
                {
                    text: "2nd Quarter",
                    value: 2,
                },
                {
                    text: "3rd Quarter",
                    value: 3,
                },
                {
                    text: "4th Quarter",
                    value: 4,
                },
            ],
            reasons: [
                'Unforeseen modification or adjustment in the Activity/Program/Initiative (API)',
                'Re-assessment in the use. Prioritization and/or distribution of resources',
                'Additional requirements for an API in view of a declaration of a state of calamity',
            ],
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
            quantityMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: false,
                allowDecimal: false,
            }),
            totalReduceQty: 0,
            accountsLoading: false,
            availableAccounts: [],
            showPO: false,
            realignmentForm: {
                id: 0,
                description: '',
                note: '',
                reason: 0,
                apiId: 0,
                newApiName: '',
                api: {
                    name: ''
                }
            },
            submitted: false,
            realignmentRemarks: [],
        }
    },
    validations: {
        proposal: {
            accountId: {required},
        },
        realignmentForm: {
            description: {required},
            newApiName: {required},
        },
    },
    computed: {
        filteredData() {
            let data = this.tableData;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
    },
    created() {
        this.getAvailableAccounts();
    },  
    methods: {
        async getAvailableAccounts() {
            this.availableAccounts = [];
            this.accountsLoading = true;
            await this.$store
                .dispatch("accounts/getAccountsForExpense")
                .then((response) => {
                    if(response.data.error){
                        return this.showToast(response.data.errorMessage, 'error');
                    }
                    // response.data.map(item => {
                    //     item.accountNameWithGroup = item.accountName + '(' + item.accountGroup.groupName + ')';
                    //     item.accountTrimmed = item.accountName.replace(/\s/g, '').trim().toLowerCase();
                    // })
                    var grps = [];
                    let grp = groupBy(response.data, 'accountGroupId');
                    for(var key in grp){
                        grps.push({
                            id: grp[key][0].id,
                            accountGroup: grp[key][0].accountGroup.groupName
                        })
                    }
                    this.availableAccounts = grps.sort((a, b) => a.accountGroup.localeCompare(b.accountGroup));
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            this.accountsLoading = false;
        },
        async getData(cycle, deliveryUnitId){
            if(this.tableData.length > 0){
                return;
            }
            this.returnedLoading = true;
            await this.$store
                .dispatch("realignmentrequest/GetReturnedRealignmentDU", {cycle, deliveryUnitId})
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    res.data.map((x) => {
                        x.viewItems = false;
                        x.realignmentItems = [];
                        x.accounts = [];
                        x.realignmentRequestItems = [];
                        x.api = {};
                        x.totalLineBudget = cloneDeep(x.total);
                        x.modificationProposal = [];
                        x.proposalCopy = [];
                        x.proposalLoading = false;
                        x.proposalLoaded = false;
                        x.addMore = false;
                        x.proposal = {
                            id: 0,
                            accountId: null,
                            account: null,
                            q1: null,
                            q2: null,
                            q3: null,
                            q4: null,
                            editMode: false,
                        };
                        x.showPO = false;
                    });
                    this.tableData = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            this.returnedLoading = false;
        },
        viewItems(row){
            row.viewItems = !row.viewItems;
            if(row.viewItems && !row.realignmentItems.length > 0){
                this.$store
                    .dispatch("realignmentrequestitem/GetRealignmentItem", row.id)
                    .then((response) => {
                        if (response.data.error) {
                            return this.showToast(response.data.errorMessage, "error");
                        }
                        let realignmentRequestItems = [];
                        if(response.data.length){
                            response.data.map(item => {
                                item.realignmentRequestItems.map(y => {
                                    y.maxValue = cloneDeep(y.quantity);
                                    y.editQty = false;
                                    y.fundSource = y.apiResourceDetail.apiResource.deliveryUnitBudgetItem.objectOfExpenditure.fundSource.sourceName;
                                    y.fundClass = y.apiResourceDetail.apiResource.deliveryUnitBudgetItem.objectOfExpenditure.accountGroup.fundClassification.classification;
                                    y.accountGroup = y.apiResourceDetail.apiResource.deliveryUnitBudgetItem.objectOfExpenditure.accountGroup.groupName;
                                    realignmentRequestItems.push(y);
                                })
                            })
                        }
                        row.realignmentRequestItems = realignmentRequestItems;
                        row.totalLineBudget = realignmentRequestItems.reduce((pv, cv) => {
                            return pv + (parseFloat(cv.total));
                        }, 0);
                    })
                    .catch((error) => {
                        row.isLoading = false;
                        this.showToast("Cannot fetch requested items", "error");
                    });

                    this.$store
                    .dispatch("realignmentaccount/GetAllRealignmentAccount", row.id)
                    .then((response) => {
                        if (response.data.error) {
                        return this.showToast(response.data.errorMessage, "error");
                        }
                        row.accounts = response.data;
                    })
                    .catch((error) => {
                        this.showToast("Cannot fetch requested accounts", "error");
                    });
            }
            this.getProposedModifications(row);
        },
        printRealignment(id){
            this.$emit("print-realignment", id);
        },
        async getProposedModifications(row){
            row.proposalLoading = true;
            row.proposalLoaded = false;
            row.modificationProposal = [];
            await this.$store
                .dispatch("realignmentaccount/GetAllRealignmentAccount", row.id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    res.data.map(item => {
                        item.editMode = false;
                        item.account = {
                            id: item.accountId,
                            accountGroup: item.accountGroup
                        }
                    })
                    row.modificationProposal = res.data;
                    row.proposalCopy = cloneDeep(res.data);
                })
                .catch((err) => {
                    this.showToast("Cannot be added!", "error");
                });
            row.proposalLoading = false;
            row.proposalLoaded = true;
        },
        totalExpenditure(row){
            if(!row.viewItems){
                return 0;
            }
            let sum = row.proposalCopy.reduce((pv, cv) => {
                return pv + (parseFloat(cv.q1) + parseFloat(cv.q2) + parseFloat(cv.q3) + parseFloat(cv.q4));
            }, 0);
            let q1 = row.proposal.q1 ? parseFloat(this.getExactAmt(row.proposal.q1)) : 0;
            let q2 = row.proposal.q2 ? parseFloat(this.getExactAmt(row.proposal.q2)) : 0;
            let q3 = row.proposal.q3 ? parseFloat(this.getExactAmt(row.proposal.q3)) : 0;
            let q4 = row.proposal.q4 ? parseFloat(this.getExactAmt(row.proposal.q4)) : 0;
            let total = sum + q1 + q2 + q3 + q4;
            return total;
        },
        addMoreProposal(row){
            this.onResetProposal(row);
            row.addMore = true;
        },
        onResetProposal(row){
            row.proposal = {
                id: 0,
                accountId: null,
                account: null,
                q1: "",
                q2: "",
                q3: "",
                q4: "",
                editMode: false,
            }
        },
        saveProposal(row){
            if(this.totalExpenditure(row) > row.totalLineBudget){
                return this.showToast('Total proposed modification is greater than total line item budget', 'error');
            }
            let data = cloneDeep(row.proposal);
            data.q1 = row.proposal.q1 ? this.getExactAmt(row.proposal.q1) : 0;
            data.q2 = row.proposal.q2 ? this.getExactAmt(row.proposal.q2) : 0;
            data.q3 = row.proposal.q3 ? this.getExactAmt(row.proposal.q3) : 0;
            data.q4 = row.proposal.q4 ? this.getExactAmt(row.proposal.q4) : 0;
            data.realignmentRequestId = row.id;
            if(row.proposal.id > 0){
                this.$store
                    .dispatch("realignmentaccount/UpdateRealignmentAccount", data)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error")
                        }
                        data.accountGroup = data.account.accountGroup;
                        let index = row.modificationProposal.findIndex(item => item.id == data.id);
                        data.editMode = false;
                        row.modificationProposal.splice(index, 1, data);
                        row.proposalCopy = cloneDeep(row.modificationProposal);
                        this.onResetProposal(row);
                        this.showToast("Successfully added!", "success")
                    })
                    .catch((err) => {
                        this.showToast("Cannot be added!", "error");
                    }
                );
            }else{
                this.$store
                    .dispatch("realignmentaccount/CreateRealignmentAccount", [data])
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error")
                        }
                        res.data.forEach((item) => {
                            item.account = data.account;
                            item.editMode = false;
                            item.accountGroup = data.account.accountGroup;
                            row.modificationProposal.push(item);
                        });
                        row.proposalCopy = cloneDeep(row.modificationProposal);
                        this.onResetProposal(row);
                        row.addMore = false;
                        this.showToast("Successfully added!", "success")
                    })
                    .catch((err) => {
                        this.showToast("Cannot be added!", "error");
                    }
                );
            }
        },
        cancelProposal(row){
            this.onResetProposal(row);
            row.addMore = false;
        },
        updateProposal(row, parent){
            parent.modificationProposal.map(item => item.editMode = false)
            let copyIndex = parent.proposalCopy.findIndex((item) => item.id == row.id);
            if(copyIndex > -1){
                parent.proposalCopy.splice(copyIndex, 1);
            }
            row.editMode = true;
            parent.proposal = cloneDeep(row);
            parent.proposal.q1 = row.q1.toString();
            parent.proposal.q2 = row.q2.toString();
            parent.proposal.q3 = row.q3.toString();
            parent.proposal.q4 = row.q4.toString();
            parent.proposal.account = {
                id: row.accountId,
                accountGroup: row.accountGroup,
            }
            parent.copiedProposal = cloneDeep(row);
            parent.proposal.editMode = true;
            
        },
        deleteProposal(row, parent){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("realignmentaccount/RemoveRealignmentAccount", row.id)
                        .then((res) => {
                            let index = parent.modificationProposal.findIndex((item) => item.id == row.id);
                            parent.modificationProposal.splice(index, 1);
                            parent.proposalCopy = cloneDeep(parent.modificationProposal);
                            this.showToast("Successfully deleted!", "success")
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        }
                    );
                }
            });
        },
        selectAccount(row, parent){
            parent.proposal.accountId = row.id;
            parent.proposal.account = {
                id: row.id,
                accountGroup: row.accountGroup,
            };
        },
        updateItem(item){
            this.totalReduceQty = 0;
            item.editQty = true;
            item.maxValue = cloneDeep(item.quantity);
            item.monthValue = cloneDeep(item.quantity.toString());
        },
        inputHandler(event, row){
            const value = event.target.value + '' + event.key;
            if(parseFloat(value) > parseFloat(row.maxValue)){
                event.preventDefault();
            }
        },
        changeItemValue(row){
            this.totalReduceQty = parseFloat(row.maxValue) - parseFloat(row.monthValue);
        },
        deleteItem(id, parent){
            let index = parent.realignmentRequestItems.findIndex((item) => item.id == id);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("realignmentrequestitem/DeleteRealignment", id)
                        .then((res) => {
                            if (res.status == 204) {
                                parent.realignmentRequestItems.splice(index, 1);
                                this.showToast("Successfully deleted!", "success");
                                this.$emit("change-item");
                            }
                        })
                        .catch((err) => {
                            this.showToast("Remove details first!", "error");
                        });
                    }
            });
        },
        removeFromModification(row, parent){
            let deleteModification = row.monthValue == 0 ? true : false;
            if(deleteModification){
                Swal.fire({
                    title: "Are you sure?",
                    text: "You put the quantity to zero. This will delete the item from the modification list. Do you want to continue?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes, remove it!",
                }).then(async (result) => {
                    if (result.value) {
                        this.$store
                            .dispatch("realignmentrequestitem/DeleteRealignment", row.id)
                            .then((res) => {
                                if (res.status == 204) {
                                    let index = parent.realignmentRequestItems.findIndex((item) => item.id == row.id);
                                    parent.realignmentRequestItems.splice(index, 1);
                                    this.$emit("change-item");
                                }
                            })
                            .catch((err) => {
                                this.showToast("Cannot be removed!", "error");
                            }
                        );
                    }
                });
            }else{
                let data = {
                    id: row.id,
                    quantity: row.monthValue,
                    apiResourceDetailId: row.apiResourceDetailId,
                }
                this.$store
                    .dispatch("realignmentrequestitem/UpdateRealignment", data)
                    .then((res) => {
                        row.quantity = row.monthValue;
                        row.total = parseFloat(row.monthValue) * parseFloat(row.apiResourceDetail.apiResource.unitCost);
                        row.editQty = false;
                        this.$emit("change-item");
                        this.showToast("Successfully updated!", "success")
                    })
                    .catch((err) => {
                        this.showToast("Cannot be update!", "error");
                    }
                );
            }
        },
        postRealignment(row){
            if(row.realignmentRequestItems.length == 0){
                this.showToast("No item to post!", "error");
                return;
            }
            if(row.modificationProposal.length == 0){
                this.showToast("No modification proposal!", "error");
                return;
            }
            Swal.fire({
                    title: "Are you sure?",
                    text: "You want to post this?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes, post this!",
                }).then(async (result) => {
                    if (result.value) {
                        this.$store
                            .dispatch("realignmentrequest/PostRealignment", row.id)
                            .then((res) => {
                                if(res.data.error){
                                    return this.showToast(res.data.errorMessage, 'error');
                                }
                                let index = this.tableData.findIndex((item) => item.id == row.id);
                                this.tableData.splice(index, 1);
                                this.$emit('repost-item', this.tableData.length)
                                this.showToast("Successfully posted!", "success")
                            })
                            .catch((err) => {
                                this.showToast("Cannot be posted!", "error");
                            }
                        );
                    }
                });
        },
        updateRealignment(realignment){
            realignment.showPO = true;
            this.realignmentForm = cloneDeep(realignment)
        },
        async removeAllPart2(parent, rows){
            for await(const row of rows){
                this.$store
                    .dispatch("realignmentrequestitem/DeleteRealignment", row.id)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast("Cannot be removed!", "error");
                        }
                        if (res.status == 204) {
                            let index = parent.realignmentRequestItems.findIndex((item) => item.id == row.id);
                            parent.realignmentRequestItems.splice(index, 1);
                            this.$emit("change-item");
                        }
                    })
                    .catch((err) => {
                        this.showToast("Cannot be removed!", "error");
                    }
                );
            }
        },
        async removeAllPart3(parent, rows){
            for await(const row of rows){
                this.$store
                    .dispatch("realignmentaccount/RemoveRealignmentAccount", row.id)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast("Cannot be removed!", "error");
                        }
                        let index = parent.modificationProposal.findIndex((item) => item.id == row.id);
                        parent.modificationProposal.splice(index, 1);
                        parent.proposalCopy = cloneDeep(parent.modificationProposal);
                    })
                    .catch((err) => {
                        this.showToast("Cannot be deleted!", "error");
                    }
                );
            }
        },
        removeRealignment(realignment){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                
                if (result.value) {
                    if(realignment.realignmentRequestItems.length){
                        await this.removeAllPart2(realignment, realignment.realignmentRequestItems);
                    }
                    if(realignment.modificationProposal.length){
                        await this.removeAllPart3(realignment, realignment.modificationProposal);
                    }
                    this.$store
                        .dispatch("realignmentrequest/DeleteRealignment", realignment.id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, 'error');
                            }
                            let index = this.tableData.findIndex((item) => item.id == realignment.id);
                            this.tableData.splice(index, 1);
                            this.$emit('repost-item', this.tableData.length)
                            this.showToast("Successfully removed!","success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        createRequest(){
            this.submitted = true;
            this.$v.realignmentForm.$touch();
            if (this.$v.realignmentForm.$invalid) {
                return;
            }
            if(this.realignmentForm.reason == 0){
                return;
            }
            let data = cloneDeep(this.realignmentForm);
            this.$store
                .dispatch("realignmentrequest/UpdateRealignment", data)
                .then((res) => {
                    let index = this.tableData.findIndex((item) => item.id == data.id);
                    data.showPO = false;
                    this.tableData.splice(index, 1, data);
                    this.showToast('Successfully updated!', 'success');
                })
                .catch((err) => {
                    this.showToast('Something went wrong!', 'error');
                });
        },
        viewLogs(realignmentId){
            this.$emit("view-logs", realignmentId);
        },
        autoGrow(element, size) {
            element.target.style.height = `${size}px`;
            element.target.style.height = `${element.target.scrollHeight}px`;
        },
        cancelUpdateProposal(row, parent){
            row.editMode = false;
            parent.proposalCopy.push(parent.copiedProposal)
            this.onResetProposal(row);
        },
        selectedAccounts(realignment){
            let accounts = [];
            this.availableAccounts.map(item => {
                let find = realignment.accounts.find(x => x.accountId == item.id);
                if(!find){
                    accounts.push(item);
                }
            })
            return accounts;
        },
    }
};
</script>
<template>
    <div>
        <div class="d-flex justify-content-between align-items-center">
            <label
                class="d-inline-flex align-items-center mb-0 me-1"
            >
                <b-form-input
                    autocomplete="off"
                    v-model.lazy="filter"
                    type="search"
                    placeholder="Search Modification..."
                    class="form-control"
                    style="width: 300px;"
                ></b-form-input>
                <b-form-select
                    class="form-select ms-1 w-25"
                    v-model="perPage"
                    :options="pageOptions"
                ></b-form-select>
            </label>
        </div>
        <div v-if="returnedLoading">
            <div
                class="
                    d-flex
                    justify-content-center
                    align-items-center
                "
            >
                <div class="preloader-component me-2">
                    <div class="status">
                        <div
                            class="
                                spinner-chase
                                w-20px
                                h-20px
                            "
                        >
                            <div
                                class="chase-dot"
                            ></div>
                            <div
                                class="chase-dot"
                            ></div>
                            <div
                                class="chase-dot"
                            ></div>
                            <div
                                class="chase-dot"
                            ></div>
                            <div
                                class="chase-dot"
                            ></div>
                            <div
                                class="chase-dot"
                            ></div>
                        </div>
                    </div>
                </div>
                <strong>Loading...</strong>
            </div>
        </div>
        <div v-if="tableData.length == 0 && !returnedLoading" class="mt-3">
            <h4>No data found...</h4>
        </div>
        <div class="card mt-3 mb-1" v-for="(realignment, index) in filteredData" :key="realignment.id">
            <header role="tab" class="card-header cursor-pointer position-relative">
                <RawData :data="realignment" v-if="$store.state.decrypt.isAdmin()" />
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <h6 class="mb-1">
                            <div class="d-flex align-items-center">
                                <div
                                    style="
                                        min-width: 30px;
                                    "
                                    class="
                                        bg-success
                                        bg-gradient
                                        text-center
                                        me-2
                                        py-1
                                        position-relative
                                    "
                                >
                                    {{index + 1}}
                                </div>
                                <div>
                                    <a href="javascript: void(0);" class="text-dark mb-0" @click="viewItems(realignment)">
                                        {{realignment.description}}
                                    </a>
                                    <div>
                                        <small><a href="javascript:void(0);" @click="printRealignment(realignment.id)"><i class="bx bx-printer"></i>Print Modification</a></small>
                                        <span class="mx-2">|</span>
                                        <small><a href="javascript:void(0);" @click="viewLogs(realignment.id)" class="text-green"><i class="bx bx-receipt"></i>View Logs</a></small>
                                    </div>
                                </div>
                            </div>
                        </h6>
                    </div>
                    <div class="d-flex align-items-center">
                        <div>
                            <span class="d-flex align-items-center" @click="viewItems(realignment)"
                                ><small>Click here to {{ realignment.viewItems ? 'minimize' : 'expand'}}</small
                                ><i
                                    class="bx bx-chevron-right rotate font-size-18 ms-3" :class="realignment.viewItems ? 'rotate-90' : 'rotate-0'"
                                ></i
                            ></span>
                        </div>
                    </div>
                </div>
            </header>
            <b-collapse
                :accordion="`savings-accordion-${realignment.id}`"
                role="tabpanel"
                :visible="realignment.viewItems"
            >
                <div class="card-body">
                    <div class="text-right mb-2 d-flex flex-row-reverse align-items-center gap-2">
                        <div>
                            <a href="javascript:void(0);" class="text-success" :id="`updateRealignment-${realignment.id}`" @click="updateRealignment(realignment)"><i class="bx bx-edit"></i> Update Modification</a> 
                            <b-popover
                                :target="`updateRealignment-${realignment.id}`"
                                triggers="click"
                                placement="right"
                                custom-class="realignment-popover"
                                :show.sync="realignment.showPO"
                            >
                                <template v-slot:title
                                    ><small>Update Modification</small></template
                                >
                                <form @submit.prevent="createRequest">
                                    <div class="mb-2">
                                        <label for="" class="text-warning">Modification Description</label>
                                        <textarea
                                            rows="1"
                                            type="text"
                                            class="form-control resize-none"
                                            placeholder="Modification Description"
                                            v-model="realignmentForm.description"
                                            @input="autoGrow($event, 15)"
                                        />
                                    </div>
                                    <div class="d-flex align-items-center cursor-pointer mb-2" @click="realignmentForm.reason = 1">
                                        <div style="height:20px;width:30px" class="border me-2" :class="{'bg-warning': realignmentForm.reason == 1}"></div>
                                        Unforeseen modification or adjustment in the Activity/Program/Initiative (API)
                                    </div>
                                    <div class="d-flex align-items-center cursor-pointer mb-2" @click="realignmentForm.reason = 2">
                                        <div style="height:20px;width:30px" class="border me-2" :class="{'bg-warning': realignmentForm.reason == 2}"></div>
                                        Re-assessment in the use. Prioritization and/or distribution of resources
                                    </div>
                                    <div class="d-flex align-items-center cursor-pointer mb-2" @click="realignmentForm.reason = 3">
                                        <div style="height:20px;width:30px" class="border me-2" :class="{'bg-warning': realignmentForm.reason == 3}"></div>
                                        Additional requirements for an API in view of a declaration of a state of calamity
                                    </div>
                                    <div class="mb-2">
                                        <label class="text-warning">Note:</label>
                                        <textarea
                                            rows="1"
                                            type="text"
                                            class="form-control resize-none"
                                            placeholder="Modification Notes"
                                            v-model="realignmentForm.note"
                                            @input="autoGrow($event, 15)"
                                        />
                                    </div>
                                    <div class="mb-2">
                                        <label class="text-warning">API:</label>
                                        <div class="form-control">{{realignmentForm.api.name}}</div>
                                    </div>
                                    <div class="mb-2">
                                        <label class="text-warning">New API Name:</label>
                                        <input type="text" class="form-control" v-model="realignmentForm.newApiName">
                                    </div>
                                    <div class="modal-footer">
                                        <button
                                            type="submit"
                                            class="btn btn-success btn-sm"
                                        >
                                            Update
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-link btn-sm"
                                            @click="realignment.showPO = false"
                                        >
                                            Close
                                        </button>
                                    </div>
                                </form>
                            </b-popover>
                            <span class="mx-2">|</span> 
                            <a href="javascript:void(0);" class="text-danger" @click="removeRealignment(realignment)"><i class="bx bx-trash"></i> Remove Modification</a>
                        </div>
                        <button v-if="realignment.proposalLoaded" type="button" class="btn btn-success" @click="postRealignment(realignment)"><i class="bx bx-check"></i> Re-Post Modification</button>
                    </div>
                    <div class="border p-3 rounded">
                        <h5 class="text-pink">Part 1: Reason of Modification of Budget</h5>
                        <p class="mb-0">
                            <span class="text-info">Reason: </span>
                            <span class="text-light">{{reasons[realignment.reason - 1]}}</span>
                        </p>
                        <p class="mb-0">
                            <span class="text-info">Explanation: </span>
                            <span class="text-light">{{realignment.note}}</span>
                        </p>
                        <hr class="mt-2 mb-3 text-warning">
                        <h5 class="text-pink">Part 2: Approved Line Item Budget to be Modified</h5>
                        <p class="mb-0" v-if="realignment.api.goal">
                            <span class="text-info">Goal: </span>
                            <span class="text-light">{{realignment.api.goal}}</span>
                        </p>
                        <p class="mb-0" v-if="realignment.api.prexc">
                            <span class="text-info">PREXC: </span>
                            <span class="text-light">{{realignment.api.prexc}}</span>
                        </p>
                        <p>
                            <span class="text-info">Activity: </span>
                            <span class="text-light">{{realignment.api.name}}</span>
                        </p>
                        <div class="table-responsive">
                            <table
                                class="
                                    table
                                    project-list-table
                                    table-centered
                                    table-borderless
                                    align-middle
                                    resource-item-table
                                "
                            >
                                <thead>
                                    <tr>
                                        <th scope="col">
                                            Item Name
                                        </th>
                                        <th
                                            scope="col"
                                            width="150px"
                                            class="
                                                text-center
                                            "
                                        >
                                            Quantity
                                        </th>
                                        <th
                                            scope="col"
                                            width="150px"
                                        >
                                            Unit Cost
                                        </th>
                                        <th
                                            scope="col"
                                            width="150px"
                                        >
                                            Total
                                        </th>
                                        <th
                                            scope="col"
                                            width="100px"
                                            class="
                                                text-center
                                            "
                                        >
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="realignment.realignmentRequestItems.length == 0">
                                        <td colspan="100%" class="text-center">No data found.</td>
                                    </tr>
                                    <tr
                                        v-for="x in realignment.realignmentRequestItems"
                                        :key="x.id"
                                        :ref="`resource-tr-${x.id}`"
                                    >
                                        <td
                                            class="
                                                border
                                                border-end-0
                                            "
                                        >
                                            <div>
                                                {{
                                                    x.apiResourceDetail.apiResource.itemName
                                                }}
                                            </div>
                                            <small>{{x.apiResourceDetail.apiResource.description}}</small>
                                            <div class="d-flex align-items-center mb-1">
                                                <span class="badge bg-secondary text-white py-1 px-2 me-2">{{ x.fundSource }}</span>
                                                <span class="badge bg-purple text-white py-1 px-2">{{ x.fundClass }}</span>
                                                <span class="badge bg-success text-white py-1 px-2 me-2"> {{ x.accountGroup }}</span>
                                            </div>
                                        </td>
                                        <td
                                            class="
                                                border
                                                border-start-0
                                                border-end-0
                                                text-center
                                            "
                                            
                                        >
                                            <span :id="`edit-itemQ-${x.id}`" class="px-2">{{
                                                numberWithCommas(x.quantity)
                                            }}</span>
                                            <b-popover
                                                    :show.sync="
                                                    x.editQty
                                                "
                                                :target="`edit-itemQ-${x.id}`"
                                                custom-class="one-month-resource"
                                                triggers="click"
                                                placement="left"
                                            >
                                                <template
                                                    v-slot:title
                                                >
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                        "
                                                    >
                                                        <small>
                                                            Item Resource Details
                                                        </small>
                                                        <span
                                                            class="
                                                                bx
                                                                bx-x
                                                                font-size-14
                                                                cursor-pointer
                                                            "
                                                            @click="
                                                                x.editQty = false
                                                            "
                                                        ></span>
                                                    </div>
                                                </template>
                                                <div>
                                                    <label for="Jan" class="mb-0">{{x.apiResourceDetail.month.monthName}} <span>(Max: {{x.maxValue}})</span></label>
                                                    <b-input-group>
                                                        <masked-input 
                                                            :mask="quantityMask" 
                                                            type="text" 
                                                            class="form-control form-control-sm text-center"  
                                                            v-model="x.monthValue"
                                                            @keypress="inputHandler($event, x)"
                                                            @keyup="changeItemValue(x)"
                                                        ></masked-input>
                                                    </b-input-group>
                                                </div>
                                                <div
                                                    class="
                                                        text-right
                                                        mt-2
                                                    "
                                                >
                                                    <button
                                                        type="button"
                                                        class="
                                                            btn
                                                            btn-success
                                                            btn-sm
                                                            me-2
                                                        "
                                                        v-if="totalReduceQty > 0"
                                                        @click="
                                                            removeFromModification(x)
                                                        "
                                                    >
                                                        Update
                                                    </button>
                                                    <button
                                                        type="button"
                                                        class="
                                                            btn
                                                            btn-link
                                                            btn-sm
                                                        "
                                                        @click="
                                                        x.editQty = false
                                                        "
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </b-popover>
                                            <div>
                                                <small class="text-warning">({{x.apiResourceDetail.month.monthName}})</small>
                                            </div>
                                        </td>
                                        <td
                                            class="
                                                border
                                                border-start-0
                                                border-end-0
                                            "
                                        >
                                            {{
                                                formatCurrency(
                                                    x.apiResourceDetail.apiResource.unitCost
                                                )
                                            }}
                                        </td>
                                        <td
                                            class="
                                                border
                                                border-start-0
                                                border-end-0
                                            "
                                        >
                                            {{
                                                formatCurrency(
                                                    x.total
                                                )
                                            }}
                                        </td>
                                        <td
                                            class="
                                                text-center
                                                border
                                                border-start-0
                                            "
                                        >
                                            <b-dropdown
                                                class="
                                                    card-drop
                                                "
                                                menu-class="dropdown-menu-end"
                                                variant="white"
                                                toggle-class="p-0"
                                            >
                                                <template
                                                    v-slot:button-content
                                                >
                                                    <i
                                                        class="
                                                            mdi
                                                            mdi-dots-horizontal
                                                            font-size-18
                                                        "
                                                    ></i>
                                                </template>
                                                <b-dropdown-item
                                                    @click="
                                                        updateItem(
                                                            x
                                                        )
                                                    "
                                                    variant="dark"
                                                    ><i
                                                        class="
                                                            bx
                                                            bx-edit
                                                            font-size-18
                                                            me-1
                                                        "
                                                    ></i
                                                    >Edit</b-dropdown-item
                                                >
                                                <b-dropdown-item
                                                    @click="
                                                        deleteItem(
                                                            x.id,
                                                            realignment
                                                        )
                                                    "
                                                    variant="danger"
                                                    ><i
                                                        class="
                                                            bx
                                                            bx-trash
                                                            font-size-18
                                                            me-1
                                                        "
                                                    ></i
                                                    >Delete</b-dropdown-item
                                                >
                                            </b-dropdown>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <hr class="mt-2 mb-3 text-warning">
                        <div>
                            <div class="d-flex justify-content-between">
                                <div>
                                    <h5 class="text-pink">Part 3: Proposed Modification</h5>
                                    <p><span class="text-info">New Activity Name:</span> {{realignment.newApiName}}</p>
                                </div>
                                <div class="text-right">
                                    <h6>Total Line Item Budget: <span class="text-warning">{{formatCurrency(realignment.totalLineBudget)}}</span></h6>
                                    <h6>Total Proposed Modification: <span class="text-warning" :class="{'text-danger': totalExpenditure(realignment) > realignment.totalLineBudget}">{{formatCurrency(totalExpenditure(realignment))}}</span></h6>
                                    <h6>Total Balance LIB: <span class="text-warning" :class="{'text-danger': (realignment.totalLineBudget - totalExpenditure(realignment)) < 0}">{{formatCurrency(realignment.totalLineBudget - totalExpenditure(realignment))}}</span></h6>
                                </div>
                            </div>
                            <table class="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>Object of Expenditure</th>
                                        <th width="150px">Quarter 1</th>
                                        <th width="150px">Quarter 2</th>
                                        <th width="150px">Quarter 3</th>
                                        <th width="150px">Quarter 4</th>
                                        <th width="90px">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="!realignment.proposalLoading && realignment.modificationProposal.length == 0">
                                        <td colspan="6" class="text-center">No data available</td>
                                    </tr>
                                    <tr v-if="realignment.proposalLoading">
                                        <td colspan="6" class="text-center">
                                            <div class="spinner-border text-primary" role="status">
                                                <span class="visually-hidden">Loading...</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <template v-if="!realignment.proposalLoading && realignment.modificationProposal.length > 0">
                                        <tr v-for="propose in realignment.modificationProposal" :key="propose.id">
                                            <td>
                                                <div v-if="!propose.editMode">{{propose.accountGroup}}</div>
                                                <div v-else>
                                                    <template v-if="accountsLoading">
                                                        <div class="spinner-border text-primary" role="status">
                                                            <span class="visually-hidden">Loading...</span>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <multiselect
                                                            v-model="propose.account"
                                                            :options="selectedAccounts(realignment)"
                                                            label="accountGroup"
                                                            @select="selectAccount($event, realignment)"
                                                            track-by="id"
                                                            value="id"
                                                            deselect-label=""
                                                            select-label=""
                                                            :allow-empty="false"
                                                        />
                                                    </template>
                                                </div>
                                            </td>
                                            <td>
                                                <div v-if="!propose.editMode">{{propose.q1 > 0 ? formatCurrency(propose.q1) : '-'}}</div>
                                                <div v-else>
                                                    <masked-input
                                                        autocomplete="off"
                                                        type="text"
                                                        v-model="realignment.proposal.q1"
                                                        class="form-control"
                                                        :mask="currencyMask"
                                                    ></masked-input>
                                                </div>
                                            </td>
                                            <td>
                                                <div v-if="!propose.editMode">{{propose.q2 > 0 ? formatCurrency(propose.q2) : '-'}}</div>
                                                <div v-else>
                                                    <masked-input
                                                        autocomplete="off"
                                                        type="text"
                                                        v-model="realignment.proposal.q2"
                                                        class="form-control"
                                                        :mask="currencyMask"
                                                    ></masked-input>
                                                </div>
                                            </td>
                                            <td>
                                                <div v-if="!propose.editMode">{{propose.q3 > 0 ? formatCurrency(propose.q3) : '-'}}</div>
                                                <div v-else>
                                                    <masked-input
                                                        autocomplete="off"
                                                        type="text"
                                                        v-model="realignment.proposal.q3"
                                                        class="form-control"
                                                        :mask="currencyMask"
                                                    ></masked-input>
                                                </div>
                                            </td>
                                            <td>
                                                <div v-if="!propose.editMode">{{propose.q4 > 0 ? formatCurrency(propose.q4) : '-'}}</div>
                                                <div v-else>
                                                    <masked-input
                                                        autocomplete="off"
                                                        type="text"
                                                        v-model="realignment.proposal.q4"
                                                        class="form-control"
                                                        :mask="currencyMask"
                                                    ></masked-input>
                                                </div>
                                            </td>
                                            <td class="text-center align-middle">
                                                <div v-if="!propose.editMode">
                                                    <a href="javascript:void(0);" @click="updateProposal(propose, realignment)" class="me-2"><i class="bx bx-edit text-success fs-5 font-weight-bold"></i></a>
                                                    <a href="javascript:void(0);" @click="deleteProposal(propose, realignment)"><i class="bx bx-trash text-danger fs-5 font-weight-bold me-2"></i></a>
                                                </div>
                                                <div v-else>
                                                    <a href="javascript:void(0);" @click="saveProposal(realignment)" class="me-2"><i class="bx bx-check text-success fs-5 font-weight-bold"></i></a>
                                                    <a href="javascript:void(0);" @click="cancelUpdateProposal(propose, realignment)"><i class="bx bx-x text-danger fs-5 font-weight-bold me-2"></i></a>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr v-if="realignment.addMore">
                                        <td>
                                            <template v-if="accountsLoading">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <multiselect
                                                    v-model="realignment.proposal.account"
                                                    :options="selectedAccounts(realignment)"
                                                    label="accountGroup"
                                                    @select="selectAccount($event, realignment)"
                                                    track-by="id"
                                                    value="id"
                                                    deselect-label=""
                                                    select-label=""
                                                    :allow-empty="false"
                                                    :class="{'is-invalid': $v.proposal.accountId.$error}"
                                                />
                                                <div v-if="$v.proposal.accountId.$error" class="invalid-feedback">
                                                    <span v-if="!$v.proposal.accountId.required">This value is required.</span>
                                                </div>
                                            </template>
                                        </td>
                                        <td>
                                            <masked-input
                                                autocomplete="off"
                                                type="text"
                                                v-model="realignment.proposal.q1"
                                                class="form-control"
                                                :mask="currencyMask"
                                            ></masked-input>
                                        </td>
                                        <td>
                                            <masked-input
                                                autocomplete="off"
                                                type="text"
                                                v-model="realignment.proposal.q2"
                                                class="form-control"
                                                :mask="currencyMask"
                                            ></masked-input>
                                        </td>
                                        <td>
                                            <masked-input
                                                autocomplete="off"
                                                type="text"
                                                v-model="realignment.proposal.q3"
                                                class="form-control"
                                                :mask="currencyMask"
                                            ></masked-input>
                                        </td>
                                        <td>
                                            <masked-input
                                                autocomplete="off"
                                                type="text"
                                                v-model="realignment.proposal.q4"
                                                class="form-control"
                                                :mask="currencyMask"
                                            ></masked-input>
                                        </td>
                                        <td class="text-center align-middle">
                                            <a href="javascript:void(0);" @click="saveProposal(realignment)" class="me-2"><i class="bx bx-check text-success fs-5 font-weight-bold"></i></a>
                                            <a href="javascript:void(0);" @click="cancelProposal(realignment)"><i class="bx bx-x text-danger fs-5 font-weight-bold me-2"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="!realignment.addMore && !realignment.proposal.editMode" @click="addMoreProposal(realignment)">
                                <button type="button" class="btn btn-success btn-block"><i class="bx bx-plus"></i> Add More</button>
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
        </div>
    </div>
</template>